import {
  getApiActionReducers,
  STATUS,
} from '@binotel-frontend/bnt-common-components';
import {createFeature, createReducer, on} from '@ngrx/store';

import {BranchActions} from './branch.actions';
import {IBranchState} from './branch-state.interface';

const branchFeatureKey = 'branchFeature';

const initialState: IBranchState = {
  branch: null,
  branchRequest: null,
  branchLoadingStatus: STATUS.default,
  favoritesStatus: null,
  favoritesStatusLoadingStatus: STATUS.default,
  branchSync: null,
  branchSyncLoadingStatus: STATUS.default,
};

const branchReducer = createReducer(
  initialState,
  ...getApiActionReducers<IBranchState>()(BranchActions.getBranch, 'branch'),
  on(
    BranchActions.getBranch.requested,
    (state, {branchId}): IBranchState => ({
      ...state,
      branchRequest: {branchId},
    })
  ),
  on(
    BranchActions.getBranch.failed,
    (state, {error, httpStatus}): IBranchState => ({
      ...state,
      branchLoadingStatus: STATUS.error({error, httpStatus}),
    })
  ),
  ...getApiActionReducers<IBranchState>()(
    BranchActions.branchSync,
    'branchSync'
  ),
  ...getApiActionReducers<IBranchState>()(
    BranchActions.getBranchFavorites,
    'favoritesStatus'
  ),
  on(
    BranchActions.markFavorite,
    (state): IBranchState =>
      state.favoritesStatus
        ? {...state, favoritesStatus: {...state.favoritesStatus, exist: true}}
        : state
  ),
  on(
    BranchActions.markFavoriteFailed,
    (state): IBranchState =>
      state.favoritesStatus
        ? {...state, favoritesStatus: {...state.favoritesStatus, exist: false}}
        : state
  ),
  on(
    BranchActions.unmarkFavorite,
    (state): IBranchState =>
      state.favoritesStatus
        ? {...state, favoritesStatus: {...state.favoritesStatus, exist: false}}
        : state
  ),
  on(
    BranchActions.unmarkFavoriteFailed,
    (state): IBranchState =>
      state.favoritesStatus
        ? {...state, favoritesStatus: {...state.favoritesStatus, exist: true}}
        : state
  ),
  on(
    BranchActions.resetFavorites,
    (state): IBranchState => ({
      ...state,
      favoritesStatus: initialState.favoritesStatus,
    })
  ),
  on(
    BranchActions.resetBranchStatus,
    (state): IBranchState => ({
      ...state,
      branchLoadingStatus: initialState.branchLoadingStatus,
    })
  ),
  on(
    BranchActions.clearBranch,
    (state): IBranchState => ({
      ...initialState,
      branchLoadingStatus: state.branchLoadingStatus,
    })
  )
);

export const branchFeature = createFeature({
  name: branchFeatureKey,
  reducer: branchReducer,
});
